// extracted by mini-css-extract-plugin
module.exports = {"divto":"OrderDetail_divto__26tuy","btn":"OrderDetail_btn__1YnpT"};